import { Box, CircularProgress } from "@mui/material";

// Small centered spinner for the narrow left-sidebar lists (folders, tags, authors).
// The masonry LoaderComponent is sized for the 4-column image gallery and looks
// broken inside these narrow columns, so InfiniteScroll's append loader uses this.
const InlineListLoader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", padding: "12px 0" }}>
    <CircularProgress size={20} />
  </Box>
);

export default InlineListLoader;
